export default "__VITE_ASSET__qyoKFR0g__"